module.exports = __webpack_public_path__ + "static/media/ship.adf98698.png";